import { useEffect } from 'react'
import { useAppStore } from '@/store/appStore'

export function VixBanner() {
  const vixValue = useAppStore(s => s.vixValue)
  const vixLastUpdated = useAppStore(s => s.vixLastUpdated)
  const vixIsStale = useAppStore(s => s.vixIsStale)
  const fetchVix = useAppStore(s => s.fetchVix)
  const priceProvider = useAppStore(s => s.priceProvider)

  useEffect(() => {
    fetchVix()
    const interval = setInterval(fetchVix, 60000)
    return () => clearInterval(interval)
  }, [fetchVix])

  const getVixColor = (value: number | null) => {
    if (value === null) return 'text-[var(--color-text-muted)]'
    if (value < 12) return 'text-[var(--color-green)]'
    if (value < 17) return 'text-[var(--color-green)]'
    if (value < 20) return 'text-[var(--color-text-primary)]'
    if (value < 25) return 'text-[var(--color-yellow)]'
    if (value < 30) return 'text-[var(--color-red)]'
    return 'text-[var(--color-red)]'
  }

  const getVixLabel = (value: number | null) => {
    if (value === null) return 'N/A'
    if (value < 12) return 'Extreme Greed'
    if (value < 17) return 'Low Fear (Greed)'
    if (value < 20) return 'Normal'
    if (value < 25) return 'Elevated Fear'
    if (value < 30) return 'Fear'
    return 'High Fear (Panic)'
  }

  const getGaugeWidth = (value: number | null) => {
    if (value === null) return '0%'
    const normalized = Math.min(Math.max((value - 10) / 70, 0), 1) * 100
    return normalized + '%'
  }

  const getGaugeColor = (value: number | null) => {
    if (value === null) return 'transparent'
    if (value < 15) return 'var(--color-green)'
    if (value < 20) return 'var(--color-accent)'
    if (value < 30) return 'var(--color-yellow)'
    return 'var(--color-red)'
  }

  return (
    <div className="flex items-center gap-4 px-4 py-2 border-b border-[var(--color-border)] bg-[var(--color-bg-secondary)]">
      <span className="text-xs font-medium text-[var(--color-text-muted)] uppercase">VIX</span>
      <span className={'text-lg font-bold ' + getVixColor(vixValue)}>
        {vixValue !== null ? vixValue.toFixed(2) : '\u2014'}
      </span>
      <div className="flex-1 max-w-48 h-2 rounded-full bg-[var(--color-bg-tertiary)] overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: getGaugeWidth(vixValue), background: getGaugeColor(vixValue) }}
        />
      </div>
      <span className="text-xs text-[var(--color-text-muted)]">{getVixLabel(vixValue)}</span>
      {vixIsStale && (
        <span className="text-xs px-2 py-0.5 rounded bg-[var(--color-yellow)]/20 text-[var(--color-yellow)]">
          Stale
        </span>
      )}
      {vixLastUpdated && !vixIsStale && (
        <span className="text-xs text-[var(--color-text-muted)]">
          {vixLastUpdated.toLocaleTimeString()}
        </span>
      )}
      {priceProvider && (
        <span className="text-[10px] px-1.5 py-0.5 rounded bg-[var(--color-bg-tertiary)] text-[var(--color-text-muted)] uppercase tracking-wide" title="Last price data provider used">
          {priceProvider}
        </span>
      )}
    </div>
  )
}
